export const newFeatures = {
    collection: {
        level: 'Уровень',
        fix_time: 'Время исправления:',
        earn_exercise: 'Заработано за упражнение:',
        on_selling: 'На продажу',
        sell: 'Продать',
        edit: 'Редактировать',
        buy: 'Купить',
        stop: 'Остановить',
        cancel: 'Отмена',
        update: 'Обновить',
        search: 'Поиск',
    },
    sort_filter: {
        sort_by: 'Сортировать по',
        filter: 'Фильтр',
        status: 'Статус',
        sell_in: 'Продажа через',
        class: 'Класс',
        sale_hight: 'Последние продажи',
        sale_low: 'Сначала старые',
        level_hight: 'Уровень: высокий к низкому',
        level_low: 'Уровень: низкий к высокому',
        reward_hight: 'Награда: высокая к низкой',
        reward_low: 'Награда: низкая к высокой',
        fix_time_hight: 'Время исправления: высокое к низкому',
        fix_time_low: 'Время исправления: низкое к высокому',
        radio_1: 'Готов к заработку',
        radio_2: 'Требует исправления',
        radio_3: 'На продажу',
        clear_all: 'Очистить все',
    },
    modal_sell: {
        fee: 'Вы получите %{fee} (~%{value}) от стоимости, если ордер на продажу выполнится успешно.',
        sell_nft: 'Продать NFT',
        edit_nft: 'Редактировать NFT',
        buy_Nft: 'Купить NFT',
        stop_sell: 'Остановить продажу',
        want_sell_in: 'Хочу продать за',
        want_buy: 'Хотите купить этот NFT?',
        want_stop: 'Хотите остановить продажу?',
        code_2fa: 'Код 2FA',
    },
    tab_leaf: {
        payment: 'Оплата',
        total_amount: 'Общая сумма',
        quantity: 'Количество',
        pay: 'Оплатить',
        balance: 'Баланс',
        limitMessage: 'Текущего баланса недостаточно!',
        you_have: 'У вас есть:',
        leaf: ' лист',
    },
    transaction: {
        transaction_history: 'История транзакций',
        type: 'Тип',
        item_id: 'ID предмета',
        tier: 'Уровень',
        level: 'Уровень',
        price: 'Цена',
        token: 'Токен',
        seller_buyer: 'Продавец/Покупатель',
        time: 'Время',
        filter: 'Фильтр',
        send: 'Отправить',
    },
    common: {
        price: 'Цена',
        noData_market: 'По вашему поиску нет соответствующих NFT.',
        edit: 'Изменить',
        no_transaction: 'У вас нет никаких транзакций.',
        all: 'Все',
        buy: 'Купить',
        sell: 'Продать',
        sent: 'Отправлено',
        receive: 'Получено',
        connect: 'Соединить',
        amount: 'Сумма',
        leaves: 'Листья ',


    },
    tab_ticket: {
        ticket: ' билет'
    },
};
